var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTranspancy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.09961 7.20016C2.89961 3.60016 6.59961 1.10016 10.8996 1.20016H10.9996C15.2996 1.20016 18.8996 3.70016 20.6996 7.20016",
    stroke: "#65B834",
    strokeWidth: 1.8111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7992 10.6006C18.9992 14.2006 15.2992 16.7006 10.9992 16.6006H10.8992C6.59922 16.6006 2.89922 14.1006 1.19922 10.6006",
    stroke: "#65B834",
    strokeWidth: 1.8111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8994 13.4004C13.3847 13.4004 15.3994 11.3857 15.3994 8.90039C15.3994 6.41511 13.3847 4.40039 10.8994 4.40039C8.41413 4.40039 6.39941 6.41511 6.39941 8.90039C6.39941 11.3857 8.41413 13.4004 10.8994 13.4004Z",
    stroke: "#65B834",
    strokeWidth: 1.8111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M10.8994 13.4004C13.3847 13.4004 15.3994 11.3857 15.3994 8.90039C15.3994 6.41511 13.3847 4.40039 10.8994 4.40039C8.41413 4.40039 6.39941 6.41511 6.39941 8.90039C6.39941 11.3857 8.41413 13.4004 10.8994 13.4004Z",
    fill: "#7FBB51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranspancy);
export default __webpack_public_path__ + "static/media/transpancy.5e689262bbb7ecbac3c1df1c0bf8ac0e.svg";
export { ForwardRef as ReactComponent };